module.exports = __webpack_public_path__ + "img/400f.9da49f7e.png";